<template lang='pug'>
  div.px-3
    v-row(v-if="currentType==='sales'")
      Sales
    v-row(v-if="currentType==='orders'")
      Orders
    v-row(v-if="currentType==='requests'")
      Requests
    v-row(v-if="currentType==='purchases'")
      Purchases
    v-row(v-if="currentType==='transfers'")
      Transfers
    v-row(v-if="currentType==='expenses'")
      Expenses
    v-row(v-if="currentType==='returns'")
      Returns
    v-row(v-if="currentType==='add-inventory'")
      addInventory
    v-row(v-if="currentType==='logs'")
      logs
    v-row(v-if="currentType==='inventory'")
      Inventory
    v-row(v-if="currentType==='summary'")
      Summary
</template>

<script>
  import Swal from 'sweetalert2'
  import Sales from './transactions/Sales'
  import Orders from './transactions/Orders'
  import Requests from './transactions/Requests'
  import Purchases from './transactions/Purchases'
  import Transfers from './transactions/Transfers'
  import Expenses from './transactions/Expenses'
  import Returns from './transactions/Returns'
  export default {
    components: {
      Sales: Sales,
      Orders: Orders,
      Requests: Requests,
      Purchases: Purchases,
      Transfers: Transfers,
      Expenses: Expenses,
      Returns: Returns,
      addInventory: () => import('./transactions/AddInventory'),
      Logs: () => import('./transactions/Logs'),
      Summary: () => import('./transactions/Summary'),
      Inventory: () => import('./transactions/Inventory'),
    },
    filters: {

    },
    data () {
      return {
        currentType: '',
      }
    },
    computed: {

    },

    watch: {
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          this.validateAccess()
          // console.log(this.$route.params.type)
        } else this.currentType = 'sales'
      },
    },
    created () {
      this.currentType = this.$route.params.type
    },
    mounted () {
      this.validateAccess()
    },

    methods: {
      async validateAccess () {
        const vm = this
        let cantAccess = true
        await vm.$store.dispatch('users/validatePemissionsCollab', this.currentType).then((res) => {
          cantAccess = res
        }).catch((erorr) => {
          cantAccess = false
        })
        if (!cantAccess) {
          Swal.fire({
            title: 'No tienes los permisos necesarios',
            text: 'No tienes permisos de acceder. Para poder acceder a esta transacción el administrador debe actualizar tus permisos',
            icon: 'warning',
            confirmButtonColor: '#2ca0a5',
            confirmButtonText: 'Aceptar',
          }).then((result) => {
            if (result.isConfirmed) {
              vm.$router.push('/dashboard')
            }
          })
        }
      },
    },

  }
</script>
